<template>
  <div class="table">
    <div class="table__row table__row--flex-row" v-show="tableFilter">
      <div class="table__row__search-filter table__white-row">
        <sm-input
          size="small"
          inputClass="table__row__search-filter__input-box"
          v-model="searchTerm"
        />

        <div class="table__row__search-filter--flex-column">
          <div class="table__row__search-filter__button-container" @click="toggleStatusesFilter">
            <span>Estado usuario</span>
            <sm-icon icon="caret-down"></sm-icon>
          </div>
          <div class="table__row__search-filter__table-filter" v-show="statusesFilter">
            <div class="table__row__search-filter__table-filter--to-left">
              <sm-checkbox
                v-model="statuses.interested"
                size="small"
              >
                Interesado
              </sm-checkbox>
              <sm-checkbox
                v-model="statuses['non-applicable']"
                size="small"
              >
                No aplica
              </sm-checkbox>
              <sm-checkbox
                v-model="statuses['in-study']"
                size="small"
              >
                En estudio
              </sm-checkbox>
              <sm-checkbox
                v-model="statuses.approved"
                size="small"
              >
                Aprobado
              </sm-checkbox>
              <sm-checkbox
                v-model="statuses.rejected"
                size="small"
              >
                Rechazado
              </sm-checkbox>
              <sm-checkbox
                v-model="statuses.payed"
                size="small"
              >
                Desembolsado
              </sm-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="table__row__toggle-search-filter">
        <sm-button
          label="Cerrar"
          size="small"
          @click="toggleTableFilter"
        />
      </div>
    </div>

    <div class="table__header">
      <div class="table__header__name">Interesados</div>
      <div class="table__header__tableRow__toggle-button">
        <sm-button
          label="Filtrar"
          size="small"
          v-show="!tableFilter"
          @click="toggleTableFilter"
        />
      </div>
    </div>

    <div class="table__content">
      <div
        v-show="isLoading"
        class="table__content_loading"
        v-bind:class="{
          'table__content_loading--tableFilter': tableFilter && !isFilterActive,
          'table__content_loading--tableFilter--filterActive': tableFilter && isFilterActive,
          'table__content_loading--filterActive': !tableFilter && isFilterActive
        }">
        <sm-inner-loading text="Cargando..." v-model="isLoading"/>
      </div>
      <div class="table__content__head">
        <div class="table__content__head__name table__content__head__name--1">Empresa</div>
        <div class="table__content__head__name table__content__head__name--2">Estado usuario</div>
        <div class="table__content__head__name table__content__head__name--3">Monto</div>
        <div class="table__content__head__name table__content__head__name--4">Última actualización</div>
        <div class="table__content__head__name table__content__head__name--5">Acciones</div>
        <div class="table__content__head__name table__content__head__name--6">Comentario</div>
      </div>

      <div v-show="users.length === 0 && !isLoading" class="table__content__no-data">
        No se encontraron resultados
      </div>

      <tableRow
        v-show="!isLoading"
        v-for="user in users"
        :key="user.idLocal ? user.idLocal : null + Math.random()*Math.random()"
        v-bind:user="user">
      </tableRow>
    </div>

    <sm-pagination
      v-show="!isLoading"
      :total="alreadyUsers.length ? alreadyUsers.length : 1"
      v-model="page"
      :items-per-page.sync="itemsPerPage"
      :items-per-page-options="itemsPerPageOptions"
    ></sm-pagination>
  </div>
</template>

<script>
import tableRow from '@/components/tableRow'

let timeout

export default {
  name: 'Table',
  components: {
    tableRow
  },
  data () {
    return {
      searchTerm: '',

      page: 0,
      itemsPerPage: 10,
      itemsPerPageOptions: [
        { value: 10, text: '10' },
        { value: 15, text: '15' },
        { value: 20, text: '20' },
        { value: 25, text: '25' },
        { value: 30, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' }
      ],

      tableFilter: false,
      statusesFilter: false,
      statuses: {
        show: false,
        interested: false,
        'non-aplicable': false,
        'in-study': false,
        approved: false,
        rejected: false,
        payed: false
      }
    }
  },
  computed: {
    alreadyUsers () {
      return this.$store.getters.leads.users.already
    },
    users () {
      let users = [...this.alreadyUsers]
      let howMany = this.itemsPerPage
      const index = howMany * this.page
      howMany = howMany < users.length ? howMany : users.length
      users = users.splice(index, howMany)
      return users
    },
    isLoading () {
      return this.$store.getters.isLoading
    },
    isFilterActive () {
      return this.$store.getters.isFilterActive
    }
  },
  watch: {
    searchTerm: function (value) {
      const prospectsFilter = this.$store.getters.prospectsFilter

      const actualSearchTerm = value
      const previousSearchTerm = prospectsFilter.name

      const isNewSearchTerm = !Object.is(actualSearchTerm, previousSearchTerm)

      if (timeout) {
        clearTimeout(timeout)
      }

      if (isNewSearchTerm) {
        this.$store.commit('prospectsFilter', { ...prospectsFilter, name: actualSearchTerm })
        timeout = setTimeout(() => {
          this.$store.dispatch('alreadyUsers')
          this.page = 0
        }, 500)
      }
    },
    statuses: {
      deep: true,
      handler: function (value) {
        const statusesKeys = Object.keys(value)
        const statuses = []

        for (const key of statusesKeys) {
          if (value[key]) {
            statuses.push(key)
          }
        }

        const prospectsFilter = this.$store.getters.prospectsFilter

        const actualStatuses = JSON.stringify(statuses)
        const previousStatuses = JSON.stringify(prospectsFilter.statuses)

        const statusesHasChanged = !Object.is(actualStatuses, previousStatuses)

        if (timeout) {
          clearTimeout(timeout)
        }

        if (statusesHasChanged) {
          this.$store.commit('prospectsFilter', { ...prospectsFilter, statuses })
          timeout = setTimeout(() => {
            this.$store.dispatch('alreadyUsers')
            this.page = 0
          }, 2000)
        }
      }
    }
  },
  methods: {
    toggleTableFilter () {
      this.tableFilter = !this.tableFilter
    },
    toggleStatusesFilter () {
      this.statusesFilter = !this.statusesFilter
    }
  }
}
</script>

<style>
.table__content_loading {
  align-items: center;
  background-color: #ffffff;
  display: flex;
  height: calc(100% - 1060px);
  justify-content: center;
  max-width: 904px;
  padding: 150px 0;
  position: absolute;
  top: 590px;
  width: calc(100% - 120px);
  z-index: 9;
}

.table__content_loading--tableFilter {
  top: 675px;
}

.table__content_loading--filterActive {
  top: 715px;
}

.table__content_loading--tableFilter--filterActive {
  top: 800px;
}

.table {
  background-color: #f2f4f8;;
  margin-bottom: 400px;
  width: 100%;
}

.table__header {
  align-items: flex-start;
  box-shadow: 0px 5px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.table__header__name {
  color: #00535e;
  font-size: 16px;
  font-weight: bold;

  background-color: #ffffff;
  border-color: #97979733;
  border-style: solid;
  border-width: 1px 1px 0 0;
  padding: 10px 10px;
  width: 160px;
}

.table__header__tableRow__toggle-button {
  align-items: center;
  display: flex;
  width: fit-content;
}

.table__content {
  background-color: #ffffff;
  border-width: 0 1px 1px 1px;
  box-shadow: 0px 4px 5px rgba(0,0,0,0.1);
  padding: 5px 10px;
}

.table__content__no-data {
  color: #b3b3b3;
  font-size: 14px;
  font-weight: 500;

  height: 25px;
  margin: 16px 0 10px 0;
  background-color: #f2f4f8;
}

.table__content__head {
  color: #00535e;
  font-size: 14px;
  font-weight: bold;

  background-color: #ededed;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
}

.table__content__head__name {
  padding: 10px 0;
}

.table__content__head__name--1 {
  text-align: left;

  padding-left: 50px;
  width: calc(100% - 720px);
}

.table__content__head__name--2 {
  text-align: left;

  width: 130px;
}

.table__content__head__name--3 {
  text-align: left;

  width: 150px;
}

.table__content__head__name--4 {
  width: 160px;
}

.table__content__head__name--5 {
  width: 130px;
}

.table__content__head__name--6 {
  padding-left: 10px;
  text-align: left;
  width: 150px;
}

.table__footer {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.table__footer__left {
  display: flex;
  flex-direction: row;
}

.table__footer__right {
  display: flex;
  flex-direction: row;
}

.table__row__search-filter {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  height: 64px;
  justify-content: space-around;
  padding: 15px 30px;
  width: calc(50% - 15px);
}

.table__row {
  margin: 5px 0;
  width: 100%;
}

.table__row--flex-row {
  align-items: center;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0px;
  margin-top: 0px;
}

.table__row__search-filter {
  align-items: flex-start;
  background-color: #FFFFFF;
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  height: 64px;
  justify-content: space-around;
  padding: 15px 30px;
  margin-bottom: 20px;
  width: calc(50% - 15px);
}

.table__row__search-filter__container {
  width: 200px;
}

.table__row__search-filter__input-box {
  height: 25px;
  width: 150px;
}

.table__row__search-filter__button-container {
  color: #999999;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: left;
  text-decoration: none;

  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  height: 25px;
  justify-content: space-between;
  margin: 5px auto;
  padding-left: 7px;
  transition: .2s;
  vertical-align: middle;
  width: 150px;
}

.table__row__search-filter__button-container:hover {
  background: #ebebeb;
  border: 1px solid #b3b3b3;
}

.table__row__search-filter__table-filter {
  float: left;
  position: relative;
  width: 150px;
}

.table__row__search-filter__table-filter--to-left {
  font-size: 12px;
  font-weight: 100;

  align-items: flex-start;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  justify-content: left;
  padding: 5px 12px 5px 5px;
}

.table__row__search-filter__by-name {
  color: #898989;
  font-size: 12px;

  border: 1px solid #bcbcbc;
  border-radius: 5px;
  height: 22px;
  padding-left: 7px;
  width: 120px;
}

.table__row--filters {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 100px;
  justify-content: space-around;
  margin-bottom: 20px;
}

.table__row__filter {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.table__row__filter__header {
  color: #00535e;
  font-size: 13px;
  font-weight: 100;
  text-align: center;

  width: fit-content;
}

.table__row__filter__body {
  color: #00535e;
  font-size: 13px;
  font-weight: bold;
  text-align: center;

  border-color: #cccccc;
  border-radius: 20px;
  border-style: solid;
  border-width: 1px;
  width: 140px;
}
</style>
